import { FC, FocusEvent } from 'react';
import { useField } from 'formik';
import { IBaseField } from './BaseField';
import { Text } from 'src/Controls';

interface ITextFieldProps extends IBaseField {
	autoFocus?: boolean;
}

/**
 * Текстовое поле
 */
const TextField: FC<ITextFieldProps> = (props) => {
	const { name, autoFocus, ...otherProps } = props;
	const [inputProps, meta, helpers] = useField(name);

	/** Очищает крайние пробелы и проверяет обновлённое значение поля */
	const onBlurHandler = async (event: FocusEvent<HTMLInputElement>) => {
		const trimmedValue = event.target.value.trim();
		if (trimmedValue !== event.target.value) {
			event.target.value = trimmedValue;
			await helpers.setValue(trimmedValue, true);
			await helpers.setTouched(true, false);
			return;
		}

		inputProps.onBlur(event);
	};

	return (
		<Text
			{...otherProps}
			{...inputProps}
			{...meta}
			autoFocus={autoFocus}
			onBlur={onBlurHandler}
		/>
	);
};

export default TextField;
